import formatAsCurrency from '../../CommonUtils/formatAsCurrency';

const assumptions = [
  {
    title: 'Purchase Year',
    key: 'PurchaseYear',
    template: ({ AtRetirement, Year }) => {
      if (AtRetirement) {
        return 'At retirement';
      }
      return Year;
    },
  },
  {
    title: 'Home Value',
    key: 'HomeValue',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'Down Payment',
    key: 'DownPayment',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'Mortgage Type',
    key: 'MortgageType',
    template: value => `${value}`,
  },
  {
    title: 'Mortgage Interest',
    key: 'MortgageInterest',
    dependsOnKey: 'MortgageType',
    template: value => `${Math.round(value * 100 * 1000) / 1000}%`,
  },
  {
    title: 'Additional Savings Per Month',
    key: 'AdditionalSavingsPerMonth',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'Property Tax',
    key: 'PropertyTaxAmount',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'PMI',
    key: 'PMI',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    title: 'Homeowners Insurance',
    key: 'HomeownersInsurance',
    template: value => formatAsCurrency(value),
  },
  {
    title: 'HOA Fees',
    key: 'HOAFees',
    template: value => `${formatAsCurrency(value)} Per Month`,
  },
  {
    title: 'Asset Allocation',
    key: 'AssetAllocation',
    template: value => value,
  },
  {
    title: 'Rate of Return',
    key: 'RateOfReturn',
    template: value => `${Math.round(value * 100 * 100) / 100}%`,
  },
  {
    title: 'Earmarked Assets',
    key: 'EarmarkedAssets',
    template: value => `Total Earmarked toward this goal ${formatAsCurrency(value)}`,
  },
];

export default assumptions;
